module.exports = __webpack_public_path__ + "static/media/mail-themed.2c5d76ac.svg";